var dataLayer = window.dataLayer;
var dataLayerUrls = window.dataLayerUrls;
var dataLayerHelper = window.dataLayerHelper;

var CHECKOUT_STEPS = {
    SHIPPING: 'shipping',
    PAYMENT: 'payment'
};

/**
 * @function
 * @description appends the parameter with the given name and value to the given url and returns the changed url
 * @param {string} url the url to which the parameter will be added
 * @param {string} name the name of the parameter
 * @param {string} value the value of the parameter
 * @returns {string} - URL with parameter
 */
function appendParamToURL(url, name, value) {
    // quit if the param already exists
    if (url.indexOf(name + '=') !== -1) {
        return url;
    }
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + name + '=' + encodeURIComponent(value);
}
/**
 * addToCart
 * @description Click event for add product to cart
 * @param {Object} productObject product object
 * @param {string} quantity product quantity added
 */
function addToCart(productObject, quantity) {
    var quantityObj = {
        quantity: quantity
    };
    var obj = {
        event: 'add_to_cart',
        ecommerce: {
            currency: dataLayerHelper.currencyCode,
            detail: {
                products: []
            }
        }
    };
    obj.ecommerce.detail.products.push($.extend(productObject, quantityObj));
    dataLayer.push(obj);
}
/**
 * removeFromCart
 * @param {Object} productObject product object
 * @param {string|number} quantity product quantity removed
 */
function removeFromCart(productObject, quantity) {
    var quantityObj = {
        quantity: quantity
    };
    var obj = {
        event: 'remove_from_cart',
        ecommerce: {
            currency: dataLayerHelper.currencyCode,
            detail: {
                products: []
            }
        }
    };
    obj.ecommerce.detail.products.push($.extend(productObject, quantityObj));
    dataLayer.push(obj);
}

/** connectConsultant
 * @param {Object} data consultant object
 * @param {string|null} formType - method is optional, CONSULTANT_METHOD.PHONE_NUMBER by default
 * @param {string|null} $form - IBC form
 * @description gets the data for connect consultant event
 */
function connectConsultant(data, formType, $form) {
    var searchMethod;
    var distance;
    var searchTerm = data && data.stores && data.stores.searchKey ? data.stores.searchKey : '';
    if (formType === 'ibcsearch-name') {
        searchMethod = 'name';
        var lastNameField = $form.find('input.js-lastName').val();
        searchTerm += ' ' + lastNameField;
        distance = undefined;
    } else if (formType === 'ibcsearch-phone') {
        searchMethod = 'phone number';
        distance = undefined;
    } else {
        searchMethod = 'zip code';
        distance = data && data.stores && data.stores.radius ? data.stores.radius : undefined;
    }
    var obj = {
        event: 'consultantLocatorSearch',
        numResults: data && data.stores && data.stores.stores && data.stores.stores.length ? data.stores.stores.length : 0,
        searchMethod: searchMethod,
        searchTerm: searchTerm,
        distance: distance
    };
    dataLayer.push(obj);
}

/** consultantLocatorLoadMore
 * @param {searchMethod} searchMethod searchMethod
 * @description gets search Method
 */
function consultantLocatorLoadMore(searchMethod) {
    dataLayer.push({
        event: 'consultantLocatorLoadMore',
        searchMethod: searchMethod
    });
}

/** getActiveFormType
* @returns {string|null} "name", "phone", "postalcode" or null
 */
function getActiveFormType() {
    if ($('form.ibcsearch-name').is(':visible')) return 'name';
    if ($('form.ibcsearch-phone').is(':visible')) return 'phone number';
    if ($('form.ibcsearch-postalcode').is(':visible')) return 'zip code';
    return null;
}

/** getSubsidiaryCode
* @returns {string|null} "SubsidiaryCode"
 */
function getSubsidiaryCode() {
    var subsidiaryCode = $('input[name="subsidiaryCode"]').val();
    return subsidiaryCode;
}

/** viewProfileSelect
 * @param {data} data data
 * @param {slotNumber} slotNumber slotNumber
 * @description gets search Method
 */
function viewProfileSelect(data, slotNumber) {
    dataLayer.push({
        event: 'viewProfileSelect',
        searchMethod: getActiveFormType(),
        referringibcId: data && data.profile && data.profile.consultantNumber ? data.profile.consultantNumber + getSubsidiaryCode() : '',
        location: getActiveFormType() ? 'Search' : 'Profile',
        searchSlot: slotNumber || null,
        activeShop: data && data.profile && data.profile.active ? 'Yes' : 'no'
    });
}

/** viewProfileSelectHeader
 * @param {consultantNumber} consultantNumber consultantNumber
 * @param {active} active active
 */
function viewProfileSelectHeader(consultantNumber, active) {
    dataLayer.push({
        event: 'viewProfileSelect',
        searchMethod: null,
        referringibcId: consultantNumber ? consultantNumber + getSubsidiaryCode() : '',
        location: 'Profile',
        searchSlot: null,
        activeShop: active ? 'Yes' : 'no'
    });
}

/** joinTeamSelect
 * @param {active} active active
 * @param {consultantNumber} consultantNumber consultantNumber
 * @param {slotNumber} slotNumber slotNumber
 * @description gets search Method
 */
function joinTeamSelect(active, consultantNumber, slotNumber) {
    const isProfileTrayOpen = $('.tray-modal.search-ibc-profile-tray').is(':visible');
    const isProfilePage = $('.ibc-profile-page.pb-4').length > 0;
    dataLayer.push({
        event: 'joinTeamSelect',
        searchMethod: getActiveFormType(),
        referringibcId: consultantNumber ? consultantNumber + getSubsidiaryCode() : '',
        location: isProfileTrayOpen || isProfilePage ? 'Profile' : 'Search',
        searchSlot: slotNumber || null,
        activeShop: active ? 'Yes' : 'no'
    });
}
/** searchResults
 * @param {searchType} searchType searchType
 * @description gets search Method
 */
function searchResultsNavigation(searchType) {
    dataLayer.push({
        event: 'searchResultsNavigation',
        searchType: searchType
    });
}
/** searchResultsLoadMore
 * @param {productSelected} productSelected productSelected
 * @description gets search Method
 */
function searchResultsLoadMore(productSelected) {
    dataLayer.push({
        event: 'searchResultsLoadMore',
        searchMethod: productSelected === 'true' ? 'Product' : 'Content'
    });
}
/** searchResultClick
 * @param {Object} data data for the clicked result
 * @param {string} data.term search term the user entered
 * @param {string} data.searchType result set the click came from (Product | Content)
 * @param {string} data.resultName name of the clicked result
 * @param {number} data.resultPosition 1-indexed position of the clicked result in the visible list
 * @description fires when a user clicks a search result (Product or Content)
 */
function searchResultClick(data) {
    dataLayer.push({
        event: 'searchResultClick',
        term: data.term,
        searchType: data.searchType,
        result_name: data.resultName,
        result_position: data.resultPosition
    });
}
/** searchSuggestionClick
 * @param {Object} data data for the clicked suggestion
 * @param {string} data.term partial term the user typed before clicking
 * @param {string} data.suggestionText text of the clicked suggestion
 * @param {number} data.suggestionPosition 1-indexed position of the suggestion in the dropdown list
 * @param {string} data.suggestionType type of the suggestion (product | content | category)
 * @description fires when a user clicks an autocomplete suggestion
 */
function searchSuggestionClick(data) {
    dataLayer.push({
        event: 'searchSuggestionClick',
        term: data.term,
        suggestion_text: data.suggestionText,
        suggestion_position: data.suggestionPosition,
        suggestion_type: data.suggestionType
    });
}
/** applyPromoCode
* @param {promoCode} promoCode promoCode
* @param {status} status of the code
*/
function applyPromoCode(promoCode, status) {
    dataLayer.push({
        event: 'apply_promo_code',
        coupon: promoCode,
        status: status
    });
}

/** removePromoCode
* @param {promoCode} promoCode promoCode
* @param {status} status of the code
*/
function removePromoCode(promoCode, status) {
    dataLayer.push({
        event: 'remove_promo_code',
        coupon: promoCode,
        status: status
    });
}

/** openCart
 * @param {response} response productData
 * @description gets the data for for add to cart
 */
function openCart() {
    dataLayer.push({
        'event': 'e_openCart'
    });
}

/** eShare
 * @param {response} response productData
 * @description gets the data for for add to cart
 */
function eAddToFav(response) {
    dataLayer.push({
        'event': 'e_addToFav',
        'favoritedProduct': response ? response.productData : ''
    });
}

/** openMinicart
*/
function openMinicart() {
    dataLayer.push({
        event: 'e_openMinicart'
    });
}
/** closeMinicart
*/
function closeMinicart() {
    dataLayer.push({
        event: 'e_closeMinicart'
    });
}
/** accountRegister
*/
function accountRegister() {
    dataLayer.push({
        event: 'accountRegister'
    });
}

/** diconnect Ibc
* @param {string} ibcId diconnect Ibc id
*/
function diconnectIbc(ibcId) {
    dataLayer.push({
        event: 'consultantLocatorDisconnect',
        referringibcId: ibcId + getSubsidiaryCode() || ''
    });
}

/** contact Ibc
* @param {string} ibcId diconnect Ibc id
* @param {string} contactType contact method
* @param {boolean} active store active
*/
function contactIbc(ibcId, contactType, active) {
    dataLayer.push({
        event: 'contactIbc',
        referringibcid: ibcId + getSubsidiaryCode() || '',
        method: contactType,
        activeShop: active ? 'yes' : 'no'
    });
}

/** findMyMatch
 * @param {Object} productData object
*/
function findMyMatch(productData) {
    dataLayer.push({
        event: 'e_findMyMatch',
        location: 'Pdp',
        findMyMatchProduct: productData
    });
}
/** tryItOn
 * @param {Object} productData object
*/
function tryItOn(productData) {
    dataLayer.push({
        event: 'e_tryItOn',
        location: 'Pdp',
        tryItOnProduct: productData
    });
}

/** contact Ibc
* @param {string} searchMethod search method type
* @param {string} ibcId Ibc id
* @param {string} location search location
* @param {string} searchSlot slot number in the search
* @param {boolean} active store active
*/
function consultantLocatorSelect(searchMethod, ibcId, location, searchSlot, active) {
    dataLayer.push({
        event: 'consultantLocatorSelect',
        searchMethod: searchMethod || null,
        referringibcId: ibcId + getSubsidiaryCode() || '',
        location: location || '',
        searchSlot: searchSlot || null,
        activeShop: active ? 'Yes' : 'no'
    });
}
/** userLogin
*/
function userLogin() {
    dataLayer.push({
        event: 'e_userLogin'
    });
}
/** homeMenuNavigation
*/
function homeMenuNavigation() {
    dataLayer.push({
        event: 'e_homeMenuNavigation'
    });
}
/** productAccordionClick
* @param {string} accordionName accordion name
*/
function productAccordionClick(accordionName) {
    dataLayer.push({
        event: 'e_productSectionExpanded',
        sectionName: accordionName
    });
}
/** function viewPromotion(creativeName, creativeSlot, promotionId, promotionName) {
* @param {string} creativeName creativeName
* @param {string} creativeSlot creativeSlot
* @param {string} promotionId promotionId
* @param {string} promotionName promotionName
*/
function viewPromotion(creativeName, creativeSlot, promotionId, promotionName) {
    dataLayer.push({
        event: 'view_promotion',
        creative_name: creativeName,
        creative_slot: creativeSlot,
        promotion_id: promotionId,
        promotion_name: promotionName
    });
}
/** function selectPromotion(creativeName, creativeSlot, promotionId, promotionName) {
* @param {string} creativeName creativeName
* @param {string} creativeSlot creativeSlot
* @param {string} promotionId promotionId
* @param {string} promotionName promotionName
* @param {Object} productData productData
*/
function selectPromotion(creativeName, creativeSlot, promotionId, promotionName, productData) {
    dataLayer.push({
        event: 'select_promotion',
        creative_name: creativeName,
        creative_slot: creativeSlot,
        promotion_id: promotionId,
        promotion_name: promotionName,
        items: productData || ''
    });
}

/**
 * Updates the current step in the checkout flow
 * @param {Integer} step the step number the flow is currently on
 */
function updateCheckoutStep(step) {
    if (step && step === CHECKOUT_STEPS.CONTESTS) {
        return;
    }
    var actionUrl = dataLayerUrls.getProductsOfCheckoutStep;
    var url = appendParamToURL(actionUrl, 'checkoutStep', step);
    $.ajax({
        url: url,
        method: 'GET',
        success: function (data) {
            var obj = {
                event: 'e_checkout',
                ecommerce: {
                    currencyCode: data.currencyCode,
                    checkout: {
                        actionField: {
                            step: data.checkoutData.step.toString()
                        },
                        products: data.checkoutData.products
                    }
                }
            };
            dataLayer.push(obj);
        }
    });
}

/**
 * Tracks interaction with a product accordion section
 * @param {string} action Expand or Collapse of the Accordion
 * @param {string} sectionType Title of the section of the accordion.
 * @param {string} sectionName The visible title of the accordion or collapsible section that was expanded by the user.
 */
function productAccordionInteraction(action, sectionType, sectionName) {
    dataLayer.push({
        event: 'e_productAccordionInteraction',
        actionType: action,
        sectionType: sectionType,
        sectionName: sectionName
    });
}

module.exports = {
    connectConsultant: connectConsultant,
    addToCart: addToCart,
    removeFromCart: removeFromCart,
    consultantLocatorLoadMore: consultantLocatorLoadMore,
    viewProfileSelect: viewProfileSelect,
    viewProfileSelectHeader: viewProfileSelectHeader,
    searchResultsNavigation: searchResultsNavigation,
    searchResultsLoadMore: searchResultsLoadMore,
    searchResultClick: searchResultClick,
    searchSuggestionClick: searchSuggestionClick,
    joinTeamSelect: joinTeamSelect,
    applyPromoCode: applyPromoCode,
    removePromoCode: removePromoCode,
    openCart: openCart,
    eAddToFav: eAddToFav,
    diconnectIbc: diconnectIbc,
    contactIbc: contactIbc,
    consultantLocatorSelect: consultantLocatorSelect,
    openMinicart: openMinicart,
    closeMinicart: closeMinicart,
    accountRegister: accountRegister,
    tryItOn: tryItOn,
    findMyMatch: findMyMatch,
    userLogin: userLogin,
    homeMenuNavigation: homeMenuNavigation,
    productAccordionClick: productAccordionClick,
    viewPromotion: viewPromotion,
    selectPromotion: selectPromotion,
    updateCheckoutStep: updateCheckoutStep,
    productAccordionInteraction: productAccordionInteraction
};
